// src/components/Phaser/PhaserTragamonedas/JuegoTragamonedas/JuegoTragamonedas.js

// Dependencias
import Phaser from 'phaser';
import axios from 'axios';
import { startDeferring, stopDeferring, dispararSaldoFinal } from '../../../../utils/saldoControl';

// Funciones JuegoTragamonedas
import { creacionElementosPrincipal } from './creacionElementos/creacionElementosPrincipal';
import { creacionParametrosPrincipal } from './creacionParametros/creacionParametrosPrincipal';

class JuegoTragamonedas extends Phaser.Scene {
  /*/=======================================================================================\*\
  ||                               //? Constructor                                           ||
  \*\=======================================================================================/*/

  constructor() {
    super({ key: 'JuegoTragamonedas' });
  }

  /*/=======================================================================================\*\
  ||                               InicioPrecarga                                            ||
  \*\=======================================================================================/*/

  preload() {}

  /*/=======================================================================================\*\
  ||                               InicioCreate                                              ||
  \*\=======================================================================================/*/

  create() {
    creacionElementosPrincipal(this);
    creacionParametrosPrincipal(this);
    this.mostrarApuestaTotal();
    this.mostrarPremioTotal();

    this.events.once('shutdown', () => {
      clearTimeout(this._timeoutPremio);
    });
    this.events.once('destroy', () => {
      clearTimeout(this._timeoutPremio);
    });
  }

  /*/=======================================================================================\*\
  ||                               FUNCIONES                                                 ||
  \*\=======================================================================================/*/

  async jugarApuesta() {
    if (
      this.game.saldoDisponible >= this.apuestaTotal &&
      this.apuestaTotal > 0
    ) {
      // Diferir actualizaciones de saldo por socket durante la animación
      startDeferring();
      this.game.saldoPendiente = null;

      // Desactivar interacciones
      this.noVaMas = true;
      this.botonJugarApuesta.setTexture('botonJugarApuestaDesactivado');
      this.botonSubirApuesta.setTexture('botonSubirApuestaDesactivado');
      this.botonBajarApuesta.setTexture('botonBajarApuestaDesactivado');
      this.premioTotal = 0;
      this.mostrarPremioTotal();

      try {
        // Enviar solo la apuesta al backend — el backend genera resultados y calcula premio
        const response = await axios.post(
          `${process.env.REACT_APP_DIRECCION}/api/jugadaTragamonedas/createJugadaTragamonedas`,
          { apuestaTotal: this.apuestaTotal },
          { withCredentials: true }
        );

        const {
          resultado_1,
          resultado_2,
          resultado_3,
          resultado_4,
          resultado_5,
          premioTotal,
          posicionesGanadoras,
        } = response.data;

        // Descontar visualmente la apuesta del saldo
        this.game.saldoDisponible -= this.apuestaTotal;
        if (this.game.onApuestaIniciada) {
          this.game.onApuestaIniciada(this.apuestaTotal);
        }

        // Guardar resultados del backend para inyectar en la animación
        this.resultadosFinales = [
          resultado_1,
          resultado_2,
          resultado_3,
          resultado_4,
          resultado_5,
        ];
        this.premioTotal = premioTotal;

        // Iniciar animación de los rodillos (los valores del backend se
        // inyectan durante el giro para que caigan en el centro naturalmente)
        this.girarRodillos();

        //-------------------------- ANIMACIÓN RESULTADO ----------------------------------\\
        this.time.delayedCall(3000, () => {
          // Sin premio: habilitar inmediatamente sin congelar la pantalla
          if (this.premioTotal === 0) {
            stopDeferring();
            this.finalizarJugada();
            return;
          }

          // Actualizar saldo 1 segundo después de mostrar el resultado
          this.time.delayedCall(1000, () => {
            const saldoFinal =
              this.game.saldoPendiente != null
                ? this.game.saldoPendiente
                : this.game.saldoDisponible + this.premioTotal;
            dispararSaldoFinal(saldoFinal);
            stopDeferring();
          });

          // Animar posiciones ganadoras
          for (const pg of posicionesGanadoras) {
            this.animarPosicionGanadora(pg.posicion, pg.valor);
          }

          this.actualizarPremioTotal();

          this.time.delayedCall(1100, () => {
            this.finalizarJugada();
          });
        });
      } catch (err) {
        console.error('Error al jugar tragamonedas:', err);
        this.noVaMas = false;
        this.botonJugarApuesta.setTexture('botonJugarApuestaEstatico');
        this.botonSubirApuesta.setTexture('botonSubirApuestaEstatico');
        this.botonBajarApuesta.setTexture('botonBajarApuestaEstatico');
        stopDeferring();
      }
    }
  }

  finalizarJugada() {
    // Aplicar saldo real pendiente al balance interno del juego
    if (this.game.saldoPendiente != null) {
      this.game.saldoDisponible = this.game.saldoPendiente;
      this.game.saldoPendiente = null;
    }

    this.noVaMas = false;
    this.botonJugarApuesta.setTexture('botonJugarApuestaEstatico');
    this.botonSubirApuesta.setTexture('botonSubirApuestaEstatico');
    this.botonBajarApuesta.setTexture('botonBajarApuestaEstatico');
  }
  animarPosicionGanadora(posicionGanadora, valorGanador) {
    if (posicionGanadora == 1) {
      this.posicion11.destroy();
      this.posicion11 = this.add
        .sprite(184, 204, `valor${valorGanador}movimiento`)
        .setVisible(true);
      this.posicion11.play(`valor${valorGanador}movimiento`);

      this.time.delayedCall(1500, () => {
        this.posicion11.stop();
        this.posicion11.destroy();
        this.posicion11 = this.add.image(
          184,
          204,
          `valor${valorGanador}Estatico`
        );
      });
    }

    if (posicionGanadora == 2) {
      this.posicion12.destroy();
      this.posicion12 = this.add
        .sprite(280, 204, `valor${valorGanador}movimiento`)
        .setVisible(true);
      this.posicion12.play(`valor${valorGanador}movimiento`);

      this.time.delayedCall(1500, () => {
        this.posicion12.stop();
        this.posicion12.destroy();
        this.posicion12 = this.add.image(
          280,
          204,
          `valor${valorGanador}Estatico`
        );
      });
    }

    if (posicionGanadora == 3) {
      this.posicion13.destroy();
      this.posicion13 = this.add
        .sprite(375, 204, `valor${valorGanador}movimiento`)
        .setVisible(true);
      this.posicion13.play(`valor${valorGanador}movimiento`);

      this.time.delayedCall(1500, () => {
        this.posicion13.stop();
        this.posicion13.destroy();
        this.posicion13 = this.add.image(
          375,
          204,
          `valor${valorGanador}Estatico`
        );
      });
    }

    if (posicionGanadora == 4) {
      this.posicion14.destroy();
      this.posicion14 = this.add
        .sprite(471, 204, `valor${valorGanador}movimiento`)
        .setVisible(true);
      this.posicion14.play(`valor${valorGanador}movimiento`);

      this.time.delayedCall(1500, () => {
        this.posicion14.stop();
        this.posicion14.destroy();
        this.posicion14 = this.add.image(
          471,
          204,
          `valor${valorGanador}Estatico`
        );
      });
    }

    if (posicionGanadora == 5) {
      this.posicion15.destroy();
      this.posicion15 = this.add
        .sprite(567, 204, `valor${valorGanador}movimiento`)
        .setVisible(true);
      this.posicion15.play(`valor${valorGanador}movimiento`);

      this.time.delayedCall(1500, () => {
        this.posicion15.stop();
        this.posicion15.destroy();
        this.posicion15 = this.add.image(
          567,
          204,
          `valor${valorGanador}Estatico`
        );
      });
    }
  }

  /*/=======================================================================================\*\
  ||                        INICIA LA ANIMACIÓN DE LOS RODILLOS                              ||
  \*\=======================================================================================/*/

  girarRodillos() {
    // Configuración para las 5 columnas
    for (let i = 1; i <= 5; i++) {
      this.time.addEvent({
        delay: i * 300, // Retraso entre columnas
        callback: () => {
          this.girarVariasVeces(i, 12); // Cada columna gira 12 veces
        },
        callbackScope: this,
      });
    }
  }

  girarVariasVeces(columna, repeticiones) {
    const duracion = 100; // Duración de la animación
    const desplazamiento = 60; // Desplazamiento vertical

    if (repeticiones > 0) {
      // En la 3ra iteración antes del final, inyectar el valor del backend
      // para que la imagen correcta caiga naturalmente en la posición central
      const valorFinal =
        repeticiones === 3 && this.resultadosFinales
          ? this.resultadosFinales[columna - 1]
          : null;

      this.moverUnRodillo(
        columna,
        duracion,
        desplazamiento,
        () => {
          // Llamar nuevamente para la siguiente iteración
          this.girarVariasVeces(columna, repeticiones - 1);
        },
        valorFinal
      );
    }
  }

  moverUnRodillo(
    indiceRodillo,
    duracion,
    desplazamiento,
    onCompleteCallback,
    valorFinal
  ) {
    const rodillo1 = indiceRodillo;
    const rodillo2 = indiceRodillo + 5;
    const rodillo3 = indiceRodillo + 10;
    const rodillo4 = indiceRodillo + 15;

    const rodillos = [rodillo1, rodillo2, rodillo3, rodillo4];

    const posiciones = [
      this[`posicion${rodillo1}`],
      this[`posicion${rodillo2}`],
      this[`posicion${rodillo3}`],
      this[`posicion${rodillo4}`],
    ];

    const filaActual = this[`ultimaFilaActualCol${indiceRodillo}`];
    const nuevaFila = filaActual === 1 ? 4 : filaActual - 1;
    this[`ultimaFilaActualCol${indiceRodillo}`] = nuevaFila;

    const posicionAnimar = posiciones[filaActual - 1];

    this.tweens.add({
      targets: posicionAnimar,
      y: posicionAnimar.y + desplazamiento,
      duration: duracion,
      ease: 'Linear',
      onComplete: () => {
        posicionAnimar.y = 84;
        // Si hay un valor final del backend, usarlo en vez de aleatorio
        const nuevoValor =
          valorFinal != null ? valorFinal : Phaser.Math.Between(1, 11);
        posicionAnimar.setTexture(`valor${nuevoValor}Estatico`);
        const claveDinamica = `valorPosicion${rodillos[filaActual - 1]}`;
        this[claveDinamica] = nuevoValor;

        // Validar y corregir posiciones de las demás imágenes
        posiciones.forEach((pos, indice) => {
          let coordenadas = 0;

          if (this[`ultimaFilaActualCol${indiceRodillo}`] == 4) {
            if (indice == 0) {
              coordenadas = 84;
            } else if (indice == 1) {
              coordenadas = 144;
            } else if (indice == 2) {
              coordenadas = 204;
            } else if (indice == 3) {
              coordenadas = 264;
            }
          } else if (this[`ultimaFilaActualCol${indiceRodillo}`] == 3) {
            if (indice == 3) {
              coordenadas = 84;
            } else if (indice == 0) {
              coordenadas = 144;
            } else if (indice == 1) {
              coordenadas = 204;
            } else if (indice == 2) {
              coordenadas = 264;
            }
          } else if (this[`ultimaFilaActualCol${indiceRodillo}`] == 2) {
            if (indice == 2) {
              coordenadas = 84;
            } else if (indice == 3) {
              coordenadas = 144;
            } else if (indice == 0) {
              coordenadas = 204;
            } else if (indice == 1) {
              coordenadas = 264;
            }
          } else if (this[`ultimaFilaActualCol${indiceRodillo}`] == 1) {
            if (indice == 1) {
              coordenadas = 84;
            } else if (indice == 2) {
              coordenadas = 144;
            } else if (indice == 3) {
              coordenadas = 204;
            } else if (indice == 0) {
              coordenadas = 264;
            }
          }

          if (pos.y != coordenadas) {
            pos.y = coordenadas;
          }
        });

        // Llamar al callback
        if (onCompleteCallback) onCompleteCallback();
      },
    });

    // Animar las demás imágenes
    posiciones.forEach((pos, index) => {
      if (index !== filaActual - 1) {
        this.animarDesplazamiento(pos, desplazamiento, duracion);
      }
    });
  }

  animarDesplazamiento(posicion, desplazamiento, duracion) {
    this.tweens.add({
      targets: posicion,
      y: posicion.y + desplazamiento,
      duration: duracion,
      ease: 'Linear',
    });
  }

  /*/=======================================================================================\*\
  ||                        FINALIZA LA ANIMACIÓN DE LOS RODILLOS                            ||
  \*\=======================================================================================/*/

  subirApuesta() {
    const saldoDisponible = this.game.saldoDisponible;
    const apuestaTotal = this.apuestaTotal;
    const valorApuesta = 100;

    if (apuestaTotal + valorApuesta <= saldoDisponible && apuestaTotal < 2000) {
      this.actualizarApuestaTotal(valorApuesta);
    }
  }

  bajarApuesta() {
    if (this.apuestaTotal > 0) {
      const valorApuesta = -100;
      this.actualizarApuestaTotal(valorApuesta);
    }
  }

  actualizarApuestaTotal(valorApuesta) {
    this.apuestaTotal += valorApuesta;
    this.mostrarApuestaTotal();
  }

  // Muestra en el display de apuesta el valor total de la apuesta
  mostrarApuestaTotal() {
    const apuestaStr = this.apuestaTotal.toString();

    let xPosition = 266;
    const yPosition = 311;

    this.limpiarApuestaTotal();

    for (let i = apuestaStr.length - 1; i >= 0; i--) {
      const digito = apuestaStr[i];

      const imagenDigito = this.add.image(
        xPosition,
        yPosition,
        `numeroDisplay${digito}`
      );
      imagenDigito.setDepth(500);
      this.imagenesNumerosApuesta.push(imagenDigito);
      xPosition -= 12;
    }
  }

  // Limpia el display de apuesta
  limpiarApuestaTotal() {
    this.imagenesNumerosApuesta.forEach((imagen) => {
      imagen.destroy();
    });
    this.imagenesNumerosApuesta = [];
  }

  // Muestra en el display de premio el valor total del premio
  mostrarPremioTotal() {
    const premioStr = this.premioTotal.toString();

    let xPosition = 599;
    const yPosition = 311;

    this.limpiarPremioTotal();

    for (let i = premioStr.length - 1; i >= 0; i--) {
      const digito = premioStr[i];

      const imagenDigito = this.add.image(
        xPosition,
        yPosition,
        `numeroDisplay${digito}`
      );
      imagenDigito.setDepth(500);
      this.imagenesNumerosPremio.push(imagenDigito);
      xPosition -= 12;
    }
  }

  // Actualiza el premio total mostrando los números intermedio en el display
  actualizarPremioTotal() {
    let xPosition = 599;
    const yPosition = 311;
    let acumGanancia = 0;
    const premioFinal = this.premioTotal;
    let aumentoIteracion = 5000;

    if (premioFinal >= 10000 && premioFinal < 100000) {
      aumentoIteracion = 500;
    } else if (premioFinal >= 100 && premioFinal < 100000) {
      aumentoIteracion = 50;
    } else if (premioFinal >= 10 && premioFinal < 100) {
      aumentoIteracion = 5;
    }

    const updateDisplay = () => {
      this.limpiarPremioTotal();

      // Convierte el valor actual a cadena
      const acumGananciaStr = acumGanancia.toString();

      // Reposiciona xPosition en cada iteración para cada número completo
      let currentXPosition = xPosition;

      for (let i = acumGananciaStr.length - 1; i >= 0; i--) {
        const digito = acumGananciaStr[i];
        const imagenDigito = this.add.image(
          currentXPosition,
          yPosition,
          `numeroDisplay${digito}`
        );
        imagenDigito.setDepth(500);
        this.imagenesNumerosPremio.push(imagenDigito);
        currentXPosition -= 12;
      }

      // Incrementa acumGanancia sin exceder premioFinal
      if (acumGanancia < premioFinal) {
        acumGanancia = Math.min(acumGanancia + aumentoIteracion, premioFinal); // Ajusta incremento sin superar premioFinal
        this._timeoutPremio = setTimeout(updateDisplay, 1); // Retraso de 1 ms entre cada incremento
      }
    };

    updateDisplay();
  }

  // Limpia el display de premio
  limpiarPremioTotal() {
    this.imagenesNumerosPremio.forEach((imagen) => {
      imagen.destroy();
    });
    this.imagenesNumerosPremio = [];
  }
}

export default JuegoTragamonedas;
